import _pt from "prop-types";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { FormattedDate, FormattedTime, IntlProvider } from 'react-intl';
import { usePkpass } from '../../../../usePkpass';
import { PkpassDateStyleTypes } from '../../../../../../../types';

const getTimeOptions = style => {
  const opts = {};
  opts.hour = '2-digit';
  opts.minute = '2-digit';
  opts.hour12 = false;

  switch (style) {
    case PkpassDateStyleTypes.PKDateStyleShort:
      break;

    case PkpassDateStyleTypes.PKDateStyleMedium:
      opts.second = '2-digit';
      break;

    case PkpassDateStyleTypes.PKDateStyleLong:
      opts.second = '2-digit';
      opts.timeZoneName = 'short';
      break;

    case PkpassDateStyleTypes.PKDateStyleFull:
      opts.second = '2-digit';
      opts.timeZoneName = 'long';
      break;

    default:
      break;
  }

  return opts;
};

const getDateOptions = style => {
  const opts = {};
  opts.year = 'numeric';

  switch (style) {
    case PkpassDateStyleTypes.PKDateStyleShort:
      opts.day = '2-digit';
      opts.month = '2-digit';
      break;

    case PkpassDateStyleTypes.PKDateStyleMedium:
      opts.day = 'numeric';
      opts.month = 'short';
      break;

    case PkpassDateStyleTypes.PKDateStyleLong:
      opts.day = 'numeric';
      opts.month = 'long';
      break;

    case PkpassDateStyleTypes.PKDateStyleFull:
      opts.day = 'numeric';
      opts.month = 'long';
      opts.weekday = 'long';
      break;

    default:
      break;
  }

  return opts;
};

export default function FieldPreviewValueDate(props) {
  const {
    language
  } = usePkpass();
  const {
    value,
    dateStyle,
    timeStyle
  } = props;
  const isDate = dateStyle !== PkpassDateStyleTypes.PKDateStyleNone;
  const isTime = timeStyle !== PkpassDateStyleTypes.PKDateStyleNone;
  let content = /*#__PURE__*/React.createElement("span", null);

  if (isDate && !isTime) {
    content = /*#__PURE__*/React.createElement(FormattedDate, _extends({
      value: new Date(value)
    }, getDateOptions(dateStyle)));
  }

  if (!isDate && isTime) {
    content = /*#__PURE__*/React.createElement(FormattedTime, _extends({
      value: new Date(value)
    }, getTimeOptions(timeStyle)));
  }

  if (isDate && isTime) {
    content = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedDate, _extends({
      value: new Date(value)
    }, getDateOptions(dateStyle))), ' ', /*#__PURE__*/React.createElement(FormattedTime, _extends({
      value: new Date(value)
    }, getTimeOptions(timeStyle))));
  }

  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: language
  }, content);
}
FieldPreviewValueDate.propTypes = {
  value: _pt.string.isRequired
};
//# sourceMappingURL=FieldPreviewValueDate.js.map